import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// pages
import SignIn from "../../pages/signIn";
import Login from "../../pages/component/login";
import Forgot from "../../pages/component/forgotPassword";
import ChangePassword from "../../pages/component/changePassword";
import { ROUTES } from "../../utils/constants";
import QRScannerPage from "../../pages/QRScanner";
import QRAttendanceLoginPage from "../../pages/QRAttendanceLogin";
import QRAttendanceListPage from "../../pages/QRAttendanceList";

export default function LoggedOutRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<Forgot />} />
      <Route
        path={`${ROUTES.CHANGE_PASSWORD.path}/:memberId/:authToken`}
        element={<ChangePassword />}
      />
      <Route path="/signin" element={<SignIn />} />
      <Route path={ROUTES.QRSCANNER.path} element={<QRScannerPage />} />
      <Route
        path={ROUTES.QRATTENDANCELOGIN.path}
        element={<QRAttendanceLoginPage />}
      />
      <Route path="/qr-attendance-list" element={<QRAttendanceListPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
